import React from 'react'
import { Link } from 'react-router'
import CSSModules from 'react-css-modules'
import styles from './menuButton.css'

const MenuButton = ({ children, onClick, icon, link, unReadMsgs }) => (
  <Link to={link} href="#" onClick={onClick} className="main-nav__item-inner">
    <svg className={'svg-icon ' + icon}>
      <use xlinkHref={'#' + icon }/>
    </svg>
    <span className="main-nav__title">{children}</span>
    {unReadMsgs ? <span className={styles.unReadMsgs}>{unReadMsgs}</span> : null}
  </Link>
)

MenuButton.propTypes = {
  children: React.PropTypes.string.isRequired,
  onClick: React.PropTypes.func
}

export default MenuButton



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/MenuButton.js